import { IUserRestrictionsResponse } from "@Interfaces";
import { Http } from "@Services";

const getUserInfo = async (
    jwtToken?: string | null
): Promise<IUserRestrictionsResponse> => {
    let response: IUserRestrictionsResponse;

    try {
        response = await Http.Request<IUserRestrictionsResponse>({
            method: "GET",
            url: "/users/me",
            headers: jwtToken
                ? { Authorization: `Bearer ${jwtToken}` }
                : undefined,
        });
    } catch (error: any) {
        const status = error?.response?.status;
        const statusText = error?.response?.statusText;
        const backendMessage = error?.response?.data?.message;
        const baseMessage =
            backendMessage ||
            statusText ||
            error?.message ||
            "Unable to fetch user info";

        throw new Error(
            status
                ? `User info request failed (${status}): ${baseMessage}`
                : baseMessage
        );
    }
    return response;
};

export default getUserInfo;
